import { buildUrl } from './build-url';

export function createProxyUrl(target, proxyBaseUrl) {
    const redirectUrl = `redirect?to=${encodeURIComponent(target)}`;
  
    return buildUrl({ target, proxyBaseUrl, stringToJoin: redirectUrl });
}